import React from 'react'
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import utils from '../../utils';

function Pagination({ count, next, previous, changePageParam }) {
    const getCurrentPage = () => {
        if (next) {
            const url = new URL(next);
            const nextPage = parseInt(url.searchParams.get('page')) || 2;
            return nextPage - 1;
        }
        if (previous) {
            const url = new URL(previous);
            const prevPage = parseInt(url.searchParams.get('page')) || 1;
            return prevPage + 1;
        }
        return 1;
    };

    const currentPage = getCurrentPage();

    const pageSize = utils.pageSize; 
    const totalPages = Math.ceil(count / pageSize);

    const getPageNumbers = () => {
        const pages = [];
        const start = Math.max(1, currentPage - 1);
        const end = Math.min(totalPages, currentPage + 1);

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    const pageNumbers = getPageNumbers();

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        changePageParam(page);
    };
    return (
        <div className="join gap-3 md:gap-7 rounded-lg shadow-md hover:shadow-xl px-3 py-2 border">
            <button
                className="join-item btn"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={!previous}
            >
                <FaChevronLeft />
            </button>

            {pageNumbers.map(page => (
                <button
                    key={page}
                    className="join-item btn"
                    onClick={() => handlePageChange(page)}
                    disabled={page === currentPage}
                >
                    {page === currentPage ? `Page ${page}` : page}
                </button>
            ))}

            <button
                className="join-item btn"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={!next}
            >
                <FaChevronRight />
            </button>
        </div>

    )
}

export default Pagination